import React from "react";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Common from "../../../layouts/Common";
import ResponsiveGallery from "react-responsive-gallery";
import appsde from "../../../assets/images/appsde.jpg";






const AppsDevelopmentWorkshop2 = () => {
  return (
    <Common>
      <section className="sub-page-banner newsr-bg">
        <Container>
          <Row>
            <Col md={12} className="text-center sup-page-inner">
              <h2>Media section</h2>
              <Breadcrumb className="text-center custom-breadcrumb">
                <Breadcrumb.Item>Home</Breadcrumb.Item>
                <Breadcrumb.Item>Media section</Breadcrumb.Item>
              </Breadcrumb>
            </Col>
          </Row>
        </Container>
      </section>
      <Container>
        <Row className="text-start mt-3">
          <Col md={12}>
            <section className="work-process mt-5">
              <h4 data-aos="flip-up">
              ঢাকায় শুরু হয়েছে পাঁচ দিনের অ্যাপস উন্নয়ন কর্মশালা। তথ্য ও যোগাযোগপ্রযুক্তি মন্ত্রণালয়ের এই উদ্যোগটি ব্যাস্তবায়নে সহায়তা করছে ইএটিএল ।

              </h4>
              <label className="text-gray mb-2 w-100">
              Dated : 13 January, 2014
              </label>
            </section>
          </Col>
        </Row>
        <Col md={12} className="mb-5 border-topn pt-3 media-galery">
          <ResponsiveGallery
            useLightBox
            images={[
              {
                src: `${appsde}`,
                alt: "med",
                orderS: 1,
                orderM: 1,
                orderL: 1,
                title:
                "ঢাকায় শুরু হয়েছে পাঁচ দিনের অ্যাপস উন্নয়ন কর্মশালা। তথ্য ও যোগাযোগপ্রযুক্তি মন্ত্রণালয়ের এই উদ্যোগটি ব্যাস্তবায়নে সহায়তা করছে ইএটিএল",
              },

            ]}
          />
        </Col>
      </Container>
    </Common>
  );
};

export default AppsDevelopmentWorkshop2;
